import { useTranslation } from "react-i18next";

import { COMPANY_CARDS_LIMITS } from "../../../../../../Pages/Companies/types";
import { useAuth } from "../../../../../../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../../../../../../roles/types/enums";
import { IGeneralDetailsProps, ROUTES } from "../../../../../../shared";
import { CompanyCardDto, DETAILS_TITLES } from "../../../../types";
import AccordionDetailsCard from "../AccordionDetailsCard/AccordionDetailsCard";

import AddCompanyCardButton from "./components/AddCompanyCardButton/AddCompanyCardButton";
import NoCompanyCards from "./components/NoCompanyCards/NoCompanyCards";
import SingleCompanyCard from "./components/SingleCompanyCard/SingleCompanyCard";

const CompanyCardsDetails = ({
  detailsData,
  isLoading
}: IGeneralDetailsProps) => {
  const { getAccessStatus } = useAuth();

  const { t } = useTranslation();

  const cardsCount: number = detailsData?.companyCards?.length ?? 0;
  const hasCompanyCards = detailsData && detailsData?.companyCards?.length > 0;

  const canManageCompanyCards = getAccessStatus(
    USER_PERMISSIONS.ManageCompanies
  );

  const renderListOfCompanyCards = () => (
    <AccordionDetailsCard
      route={ROUTES.Companies}
      cardTitle={t(`Details##${DETAILS_TITLES.CompanyCards}`)}
      maxCount={COMPANY_CARDS_LIMITS.MaxResourceCount}
      currentCount={cardsCount}
      quickTitleAction={
        canManageCompanyCards && (
          <AddCompanyCardButton
            detailsData={detailsData}
            cardsCount={cardsCount}
          />
        )
      }
    >
      {detailsData?.companyCards?.map((card: CompanyCardDto, index: number) => (
        <SingleCompanyCard
          key={card.id}
          cardData={card}
          index={index}
          totalCount={cardsCount}
          companyData={detailsData}
          canManageCompanyCards={canManageCompanyCards}
        />
      ))}
    </AccordionDetailsCard>
  );

  return isLoading ? (
    <></>
  ) : (
    <>
      {!hasCompanyCards && (
        <NoCompanyCards currentCount={cardsCount} detailsData={detailsData} />
      )}
      {hasCompanyCards && renderListOfCompanyCards()}
    </>
  );
};

export default CompanyCardsDetails;
